const SOLANA_ADDRESS = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
const EVM_ADDRESS = /^0x[0-9a-fA-F]{40}$/;

export const isSolanaAddress = (input: string): boolean => SOLANA_ADDRESS.test(input);
export const isEvmAddress = (input: string): boolean => EVM_ADDRESS.test(input);
/** Solana or EVM wallet (CollectorCrypt gacha went multichain on 2026-10-26). */
export const isWalletAddress = (input: string): boolean =>
  isSolanaAddress(input) || isEvmAddress(input);

/** Block explorer for a wallet: Solscan for Solana, Blockscan (all EVM chains) for 0x. */
export const explorerLink = (address: string): { href: string; label: string } =>
  isEvmAddress(address)
    ? { href: `https://blockscan.com/address/${address}`, label: "Blockscan" }
    : { href: `https://solscan.io/account/${address}`, label: "Solscan" };

export type ParsedSearch =
  | { kind: "wallet"; address: string }
  | { kind: "refcode"; refcode: string };

/**
 * Turn whatever was pasted into the search box into a wallet address or a
 * refcode. Accepts a bare address, an explorer URL (Solscan, Solana FM,
 * Solana Explorer, this site's own /wallet/... links) or a refcode.
 */
export function parseSearchInput(raw: string): ParsedSearch | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (isWalletAddress(trimmed)) return { kind: "wallet", address: trimmed };

  // URL: take the first path segment that looks like an address
  if (/^https?:\/\//i.test(trimmed) || /^[\w.-]+\.[a-z]{2,}\//i.test(trimmed)) {
    try {
      const url = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);
      const address = url.pathname.split("/").find((segment) => isWalletAddress(segment));
      if (address) return { kind: "wallet", address };
    } catch {
      /* not a URL after all */
    }
  }

  return { kind: "refcode", refcode: trimmed };
}

/** "7xKp…9Qm2" for tight spaces. */
export const shortAddress = (address: string, chars = 4): string =>
  address.length <= chars * 2 + 1 ? address : `${address.slice(0, chars)}…${address.slice(-chars)}`;
